export function getEnvVar(name: string, args?: { required?: boolean }) {
  const { required = true } = args ?? {};
  const value = process.env[name];
  if (required && !value) {
    throw new Error(`Environment variable ${name} is required.`);
  }
  return value;
}
